import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "../GinGame/Button/Button";
import CongratsImg from "../../assets/Game/GinRummy/images/congratulations.png";
import LoseGame from "../../assets/Game/GinRummy/images/loseGame.png";
import PlayGame from '../../assets/Game/GinRummy/images/playGame.png';
import BackArrowImg from '../../assets/Game/GinRummy/images/backArrow.png'
import "./GinGameScore.css";
import { useNavigate } from "react-router-dom";
import { saveFirstPlayerCard, saveScore, useUpdatePlayersCardP2PMutation } from "../../features/UserFeatures/Cards/cardsSave/CardsSaveSlice";
import { useDispatch } from "react-redux";

const GinGameWinPage = ({ onHide, totalBotScore, totalPlayerScore, showdata, setShow, multiplayerGame, ...props }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    // const accessToken = localStorage.getItem("token");
    const UserId1 = localStorage.getItem("userId")
    const UserName1 = localStorage.getItem("userName")
    // console.log("UserId1", UserId1, UserName1)
    const [fetchUpdateId] = useUpdatePlayersCardP2PMutation()
    const userId = localStorage.getItem("userId")
    const roomId = localStorage.getItem("roomId")
    const transformedData = {
        roomId: roomId,
        userId: userId,
        playerCard: "",
        deckCard: "",
        openCard: "",
        player: "",
        roundCount: 0,
        turnPlayer: "",
        gameEndMessage: "Completed",
        isGameEnd: true,
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        createdDate: new Date(),
        createdBy: "",
        modifiedDate: new Date(),
        isDeleted: true,
        isActive: true,
        deletedOn: new Date(),
        modifiedBy: "",
    };
    const startGameHandler = async () => {
        // console.log("modedsadsadsadsales")
        // window.location.reload(false)
        console.log("transformedData", transformedData)
        const updateData = await fetchUpdateId(transformedData)
        console.log("updateData", updateData)
        dispatch(saveScore([]))
        dispatch(saveFirstPlayerCard([]))
        navigate('/ginGame')
        localStorage.removeItem('roomId')
        localStorage.removeItem('userName2')
        localStorage.removeItem('userId2')
        localStorage.removeItem('roundCount')
        localStorage.removeItem('deadwood')
    }

    const exitBtn = async () => {
        console.log("transformedData", transformedData)
        const updateData = await fetchUpdateId(transformedData)
        console.log("updateData", updateData)
        dispatch(saveScore([]))
        dispatch(saveFirstPlayerCard([]))
        navigate('/ginGame')
        localStorage.removeItem("roomId")
        localStorage.removeItem('userName2')
        localStorage.removeItem('userId2')
        localStorage.removeItem('roundCount')
        localStorage.removeItem('deadwood')
    };

    return (
        <>

            {/* win modfal */}
            <Modal
                {...props}
                // onHide={onHide}
                show={showdata === "win" ? true : false}
                size="lg"
                aria-labelledby="GinGameWinPage"
                centered
            >
                <Modal.Header className="justify-content-end border-0" >
                </Modal.Header>
                <Modal.Body>
                    <div>

                        <div class="fireWork">
                            <div class="before"></div>
                            <div class="after"></div>
                        </div>
                    </div>

                    <div className="text-center text-white">
                        <img src={CongratsImg} className="img-fluid w-25" alt="" />
                        <h1 className="modalHeader">Congratulations</h1>
                        <h3 className="fancy">You Won!</h3>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0 actionBtn">
                    <Button src={PlayGame} onClick={() => startGameHandler()} btnName="New Game" />
                    <Button src={BackArrowImg} btnName="Exit" onClick={() => exitBtn()} />
                </Modal.Footer>
            </Modal>

            {/* loose modal */}
            <Modal
                {...props}
                // onHide={onHide}
                show={showdata === "loose" ? true : false}
                size="lg"
                aria-labelledby="GinGameWinPage"
                centered
            >
                <Modal.Header className="justify-content-end border-0" >
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center text-white">
                        <img src={LoseGame} className="img-fluid w-25" alt="" />
                        <h1 className="modalHeader">Sorry!</h1>
                        <h3 className="fancy">You Loose</h3>
                    </div>

                </Modal.Body> <Modal.Footer className="border-0 actionBtn">
                    <Button src={PlayGame} onClick={() => startGameHandler()} btnName="New Game" />
                    <Button src={BackArrowImg} btnName="Exit" onClick={() => exitBtn()} />
                </Modal.Footer>
            </Modal>

        </>


    );
};

export default GinGameWinPage;
